import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FETCH_GROUPUNITS } from './actions.type'
import { SET_GROUPUNITS, SET_GROUPUNITS_ERRORS, SET_GROUPUNITS_LOADING } from './mutations.type'

const state = {
	groupUnits: [],
	groupUnitsErrors: [],
	groupUnitsIsLoading: false
}

const getters = {
	groupUnits() {
		return state.groupUnits
	},
	groupUnitsFindByDn : state => dn => {
		return state.groupUnits.find(x => x.dn.toLowerCase() == dn.toLowerCase())
	},
	groupUnitsErrors() {
		return state.groupUnitsErrors
	},
	groupUnitsIsLoading() {
		return state.groupUnitsIsLoading
	}
}

const actions = {
	[FETCH_GROUPUNITS] (context, params) {
		context.commit(SET_GROUPUNITS_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.query('manager/groupunits')
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_GROUPUNITS, data)
					resolve(data)
				} else {
					context.commit(SET_GROUPUNITS_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_GROUPUNITS_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_GROUPUNITS_LOADING, false)
			})
		})
	}
}

const mutations = {
	[SET_GROUPUNITS] (state, data) {
		state.groupUnits = data
		state.groupUnitsErrors = []
	},
	[SET_GROUPUNITS_ERRORS] (state, errors) {
		state.groupUnits = []
		state.groupUnitsErrors = errors
	},
	[SET_GROUPUNITS_LOADING] (state, status = true) {
		state.groupUnitsIsLoading = status
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/groupunits.module.js